import React from 'react';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';
import InvalidProviderToChangePassword from '../../pages/ErrorPage/InvalidProviderToChangePassword';
import RedirectPage from '../../pages/RedirectPage/RedirectPage';
import { setUser } from '../../redux/actions';
import ConfirmPassword from '../ConfirmPassword/ConfirmPassword';
import LinkMyAccount from '../LinkMyAccount/LinkMyAccount';
import SpinnerPage from '../SpinnerPage/SpinnerPage';
import TOS from '../TOS/TOS';
import handleIdpLogin from './helpers/handleIdpLogin';
import SignInContainer from './signInContainer';
import { useAuthenticator } from '@aws-amplify/ui-react';
import MFASelection from '../MFA/mfaSelection';
import awsconfig from "../../aws-exports";

const config = require("Config");


const mapStateToProps = (state) => {
	return {
		user: state.app.user,
		lang: state.app.lang,
		tos: state.app.tos,
	}
};

const LandingPage = (props) => {

	handleIdpLogin.bind(this);

	let location = useLocation();

	const { route, user, authStatus } = useAuthenticator((context) => [context.route, context.user, context.authStatus]);

	const [isLinkAccountFlow, setIsLinkAccountFlow] = React.useState(sessionStorage.getItem("link_acc_token") || null);
	const [open, setOpen] = React.useState(true);

	const handleClose = (value) => {
		setOpen(false);
		setIsLinkAccountFlow(false);
	};

	if ((props.initialAuthState === 'confirmPassword' || location.pathname === "/confirmPassword"))
		return <ConfirmPassword />

	if (props.route === "confirmSignUp" && props.authStatus === "unauthenticated" && !props.user)
		return <SignInContainer authState={props.authStatus} route={props.route} />

	if (props.provider !== 'cognito' && (props.initialAuthState === 'changePassword' || location.pathname === "/changePassword"))
		return <InvalidProviderToChangePassword provider={props.provider} />

	if (route === "confirmSignIn" && authStatus === "unauthenticated" && user && !user.signInUserSession) {
		return <MFASelection isAuthenticatorSetupRequired={user.challengeName !== "SOFTWARE_TOKEN_MFA"}/>
	}
	if (((route === "confirmSignIn" && authStatus === "unauthenticated" && user && user.signInUserSession) || (props.authStatus === "authenticated" && props.user)) && props.initialAuthState !== 'resetPassword' && props.initialAuthState !== 'changePassword' && location.pathname !== "/changePassword" && location.pathname !== "/resetPassword") {
		const currentUser = props.user ? props.user : user;
		const mfaRequiredForUser = currentUser.signInUserSession.idToken.payload["mfaRequired"] ?? "true";
		const tosId = currentUser.signInUserSession.idToken.payload["tosVersionId"]

		if (user && !props.user) {
			props.setUser(user);
		}
		if (awsconfig.mfaEnabled && mfaRequiredForUser === "true" && currentUser.preferredMFA === "NOMFA"){
			return <MFASelection isAuthenticatorSetupRequired={currentUser.preferredMFA === "NOMFA"}/>
		}
		if ((config.enableGusIntegration && !props.tos))
			return <SpinnerPage state={{ from: location }} />
		if ((config.enableGusIntegration && props.tos._id !== tosId && !props.tos.isAgreed))
			return <TOS />
		return <RedirectPage to={config.brightPathUrl} />
	}

	if (isLinkAccountFlow && props.authStatus !== "authenticated")
		return <LinkMyAccount isLinkAccountFlow={isLinkAccountFlow} currentStep={2} open={open} onClose={handleClose} />

	if (props.route === "verifyUser" || props.route === "resetPassword" || props.route === "confirmResetPassword" || props.route === "confirmVerifyUser")
		return <SignInContainer initialAuthState={props.initialAuthState} authState={props.authStatus} route={props.route} />

	if ((props.authStatus !== "authenticated") && !props.user && props.route === "setup")
		return <SignInContainer initialAuthState={props.initialAuthState} authState={props.authStatus} route={props.route} />

	if ((props.authStatus === "unauthenticated") && !props.user && (props.route === "signIn" || props.route === "signUp"))
		return <SignInContainer initialAuthState={props.initialAuthState} authState={props.authStatus} route={props.route} />

	if ((props.authStatus !== "authenticated" && props.route !== "configuring" && props.authStatus !== "verifyUser") ||
		((props.authStatus === "authenticated") && !props.user)) {
		return <SpinnerPage state={{ from: location }} />
	}

	return <SignInContainer initialAuthState={props.initialAuthState} authState={props.authStatus} route={props.route} />
};

export default connect(mapStateToProps, { setUser })(LandingPage);
